const verify = {
  'minLength':function(obj,value){
    if(obj.minLength >= value.length){
      return `value is not above minimum length ${obj.minLength}`
    }
    return true;
  },
  'pattern':function(obj, value){
    let emailFormat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    switch(obj['pattern']){
      case "email":
        if(value.match(emailFormat)){
          return true;
        }
        return "Invalid Email"
      default:
        return "Error No case match"
    }
  },
  'chars':function(obj,value){
    let charsOk = value.split("").every(c => obj['chars'].indexOf(c) >= 0);
    if(charsOk === true){
      return true;
    }
    return `invalid character possible characters: ${obj['chars']}`
  },
  'limit':function(value,char,limit){
    let count = value.split("").reduce((acc,cv) => cv === char ? acc+=1 : acc, 0);
    if(count > limit){
      return `Error limit ${limit} exceeded for character ${char}`
    }
    return true;

  },
  'limitchars':function(obj,value){
    let { limitchars, limit } = obj
    let result = limitchars.map(c => {
      return this.limit(value,c,limit)
    }).find(x => typeof(x) === "string")
    if(result === undefined){
      return true;
    }
    return result;
  },
  'maxLength':function(obj,value){
    if(obj.maxLength >= value.length){
      return true;
    }
    return `value is above maximum length ${obj.maxLength}`
  },
  'whitespace':function(obj,value){
    let isspace = value.split("").indexOf(" ") >= 0;
    if(isspace === true){
      return "Cannot have spaces, please remove empty spaces";
    }
    return true;
  }
}
export const verifier = (arr) => ( value) => {
  return arr.reduce((acc,cv) => {
    if(typeof(acc) === "string"){
      return acc;
    }
    let key = Object.keys(cv)[0]
    if(verify[key] !== undefined){
      acc = verify[key](cv,value)
    }
    return acc;
  },true)
}
